export default {"src":"/_next/static/media/menu-bg-white.e7ec66fb.svg","height":812,"width":375,"blurWidth":0,"blurHeight":0};